module.exports = "/assets/logo_sg_photoshop_1_1-c56881e3fca997a2c19892fd8eff2661.png";